// extracted by mini-css-extract-plugin
module.exports = {"dialog":"NewSupplierModal_dialog__2F2GM","container":"NewSupplierModal_container__Q_3aL","content":"NewSupplierModal_content__2j4kM","input":"NewSupplierModal_input__3BwGA"};